import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import SideMenu from "./SideMenu";
import Footer from "./Footer"; // Import the Footer component

function Layout() {
  return (
    <>
      <div className="md:h-14">
        <Header />
      </div>
      <div className="grid grid-cols-12 min-h-screen md:h-fit bg-stone-300 items-baseline">
        <div className="col-span-2 h-screen overflow-y-auto sticky top-0 hidden lg:flex">
          <SideMenu />
        </div>
        <div className="col-span-10">
          <Outlet />

        </div>

      </div>
      <Footer />

    </>
  );
}

export default Layout;
